let Modals = require('sma.common/components/modals');

const ajax = require('sma.common/ajax');

const decisionModalTempl = require('sma.applicant/components/partials/decision.mustache');

const DECISIONS = {
	defer: 1,
	accept: 2,
	decline: 3,
};


class ApplicantDecisionModal extends Modals.TemplateModal {
	get template() {
		return decisionModalTempl;
	}

	constructor(options, ctx) {
		ctx.strings = {
			awarded: gettext('Awarded'),
			applicant_note_label: gettext('Send a message to the program administrator about your decision (optional)'),
		};
		ctx.application_title = ctx.submission.title !== ctx.submission.reference_id ? ctx.submission.title : '';
		if (ctx.submission.decision.applicant_decision_deadline){
			ctx.decision_deadline_message = interpolate(
				gettext('A decision is required by <label>%(deadline)s</label>'), {
					deadline: ctx.submission.decision.applicant_decision_deadline
				}, true
			);
		} else {
			ctx.decision_deadline_message = gettext('A decision is required.');
		}
		options['buttons'] = [
			{
				label: gettext('Decline'),
				cls: 'btn-link',
				handler: () => {
					this.applyDecision(DECISIONS.decline);
				}
			}, {
				label: gettext('Accept'),
				cls: 'btn-primary',
				handler: () => {
					this.applyDecision(DECISIONS.accept);
				}
			}, {
				label: gettext("I'll decide later"),
				cls: 'btn-link float-left',
				handler: () => {
					this.applyDecision(DECISIONS.defer);
				}
			}
		];
		super(options, ctx);
		this.handleOptions(options);
		this.modalHeader.addClass('p-3');
		this.submission_id = ctx.submission.id;
		this.$decisionCallout = options.$decisionCallout;
	}

	deferDecision() {
		this.applyDecision(DECISIONS.defer);
	}

	applyDecision(decision) {
		const message = this.modalBody.find('#applicant-note').val();
		const options = {
			url: reverse('edit-applicant-award-decision', { app_id: this.submission_id }),
			data: {
				decision,
				message,
			},
			callback: () => {
				this.postDecisionCallback(decision);
			},
		};
		ajax.post(options);
	}

	postDecisionCallback(decision) {
		this.hide();
		if (decision === DECISIONS.accept) {
			setTimeout(function (){
				window.location.reload();
			}, 2000);
		} else if (decision === DECISIONS.decline) {
			setTimeout(function (){
				window.location.href = reverse('application-dashboard');
			}, 2000);
		}
	}
}

module.exports = ApplicantDecisionModal;